
import DetailsPageHeader from '../../components/DetailsPageHeader';

import ManagerSidebar from '../../components/manager/ManagerSidebar';
import ManagerCustomerDetailsTab from '../../components/manager/ManagerCustomerDetailsTab';


const ManagerCustomerDetailsScreen = () => {

  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
            <ManagerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'Customers'} customerDetails={'Phoebe Buffay'} showCreateCustomerButton={true}/>
            <section className='mt-10 flex gap-5'>
                <div className=''>
                    <div className='laundry-details-title-items gap-10'>
                        <div className='employee-initials-border'>
                            {/* <MultiFileIcon className='ml-5 mt-5'/> */}
                            <p className='employee-initials'>MS</p>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <p className='order-id'>Phoebe Buffay</p>
                            <div className='flex gap-4 employee-role-border'>
                                <p className='employee-role'>Personal Account</p>
                                
                            </div>
                            
                        </div>
                        <section className='active-more-options flex gap-10'>
                            {/* <div className='flex gap-4 mt-3.5'>
                                <button className="toggle-button mt-1.5" onClick={handleToggle}>
                                    {isToggled ? <ToggleButtonOff /> : <ToggleButtonOn />}
                                </button>
                                <p className='employee-active'>Active</p>
                                
                            </div>
                             */}
                            <div className='order-status-option-dropdown customer-details-status-option-dropdown'>
                                
                                <select className='mt-6'>
                                    <option value="option1">More options</option>
                                    <option value="option2">Edit Customer</option>
                                    <option value="option3">Archive Customer</option>
                                   
                                </select>
                            
                            </div>
                        </section>
                        
                    </div>
                    
                </div>
               
            </section>
            <section className='mt-20 flex gap-4'>
                <section>
                    <ManagerCustomerDetailsTab/>
            </section>
            
          </section>
        </main>
      </section>
    </>
  )
}

export default ManagerCustomerDetailsScreen